import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";

@Component({
	selector: "app-shaft-order",
	imports: [FormsModule],
	templateUrl: "./shaft-order.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class ShaftOrderComponent {
	@Input()
	public showShaftOrder = true;
	@Input()
	public shaftOrder: number;
	// Two-way binding support: [(shaftOrder)]
	@Output()
	public shaftOrderChange = new EventEmitter<number>();

	@Input()
	public showOneRev = false;
	@Input()
	public oneRevOnly: boolean;
	// Two-way binding support: [(oneRevOnly)]
	@Output()
	public oneRevOnlyChange = new EventEmitter<boolean>();

	// Fires after a control changes so the host can refresh (updatePlot/loadRegimes/etc.)
	@Output()
	public refresh = new EventEmitter<void>();

	public setOrder(value: number) {
		this.shaftOrder = value;
		this.shaftOrderChange.emit(value);
		this.refresh.emit();
	}

	public setOneRev(value: boolean) {
		this.oneRevOnly = value;
		this.oneRevOnlyChange.emit(value);
		this.refresh.emit();
	}
}
